export const conditionOptions = [
  { value: "New", label: "New" },
  { value: "Like new", label: "Like new" },
  { value: "Very good", label: "Very good" },
  { value: "Good", label: "Good" },
  { value: "Well worn", label: "Well worn" },
];
